import React from 'react';
import { Link } from 'react-router-dom';
import { Youtube, Twitter, Linkedin, Facebook, Instagram, Send } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="border-t border-gray-800 bg-[#060810] py-12 mt-auto text-gray-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-8">
        <div>
          <Link to="/" className="flex items-center mb-4">
            <img
              src="/assets/website_header only logo.png"
              alt="ForexFund Logo"
              className="h-8 w-auto object-contain"
            />
          </Link>
          <p className="text-sm text-gray-400">
            Institutional intelligence for the modern retail trader. Gain your trading edge today.
          </p>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-xs">Platform</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/dashboard" className="hover:text-finance-accent transition-colors">Institutional Dashboard</Link></li>
            <li><Link to="/pricing" className="hover:text-finance-accent transition-colors">Pricing & Plans</Link></li>
            <li><Link to="/login" className="hover:text-finance-accent transition-colors">Log In / Register</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-xs">Institutional Tools</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/features/fundamental" className="hover:text-finance-accent transition-colors">Fundamental Analysis</Link></li>
            <li><Link to="/features/cot" className="hover:text-finance-accent transition-colors">COT Report Insights</Link></li>
            <li><Link to="/features/order-flow" className="hover:text-finance-accent transition-colors">Order Flow Maps</Link></li>
            <li><Link to="/features/charts" className="hover:text-finance-accent transition-colors">Market Forecasts</Link></li>
            <li><Link to="/features/standard-signals" className="hover:text-finance-accent transition-colors">Standard Signals</Link></li>
            <li><Link to="/features/elite-signals" className="hover:text-finance-accent transition-colors">Elite Signals</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-xs">Resources</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-finance-accent transition-colors">About Us</Link></li>
            <li><Link to="/insights" className="hover:text-finance-accent transition-colors">Market Insights</Link></li>
            <li><Link to="/insights/why-is-my-gold-strategy-failing-today" className="hover:text-finance-accent transition-colors">Why Gold Strategies Fail</Link></li>
            <li><Link to="/insights/what-is-a-breaker-block-in-smc-institutional-view" className="hover:text-finance-accent transition-colors">SMC Breaker Blocks</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-xs">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" className="hover:text-finance-accent transition-colors">Terms of Service</Link></li>
            <li><Link to="/privacy" className="hover:text-finance-accent transition-colors">Privacy Policy</Link></li>
            <li><Link to="/disclaimer" className="hover:text-finance-accent transition-colors">Risk Disclaimer</Link></li>
            <li><Link to="/terms#refund" className="hover:text-finance-accent transition-colors">Refund Policy</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-xs">Contact</h4>
          <ul className="space-y-2 text-sm mb-6">
            <li>
              <Link to="/support" className="hover:text-finance-accent transition-colors">Email Us Now</Link>
            </li>
            <li>
              <button
                onClick={() => {
                  const supportBtn = document.querySelector('button[class*="fixed bottom-6 right-6"]');
                  if (supportBtn) (supportBtn as HTMLElement).click();
                }}
                className="hover:text-finance-accent transition-colors text-left"
              >
                Live Chat
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-8 border-t border-gray-800 text-xs text-center md:text-left">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div>
            <p>&copy; {new Date().getFullYear()} ForexFund AI. All rights reserved.</p>
            <p className="mt-2 text-gray-500 max-w-3xl">Trading foreign exchange on margin carries a high level of risk, and may not be suitable for all investors.</p>
          </div>
          <div className="flex gap-4 shrink-0">
            <a href="#" className="text-gray-400 hover:text-white transition-colors" aria-label="YouTube">
              <Youtube className="w-5 h-5" />
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors" aria-label="X (Twitter)">
              <Twitter className="w-5 h-5" />
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn">
              <Linkedin className="w-5 h-5" />
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors" aria-label="Facebook">
              <Facebook className="w-5 h-5" />
            </a>
            <a href="https://t.me/forexfundai" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#229ED9] transition-colors" aria-label="Telegram">
              <Send className="w-5 h-5" />
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors" aria-label="Instagram">
              <Instagram className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
